import script from "./BusinesstypeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./BusinesstypeView.vue?vue&type=script&lang=ts&setup=true"

import "./BusinesstypeView.vue?vue&type=style&index=0&id=34a7a133&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a7a133"]])

export default __exports__